export enum CookieName {
  FIREBASE_TOKEN = 'firebase-token',
  FIREBASE_MSISDN = 'firebase-msisdn',
}
